import Loyalty from './loyalty';

export {
	Loyalty,
};
